// Vuex transaction module mutations
import { 
  FILL_DETAILS,
  FILL_RECORDS_CART,
  REMOVE_FROM_RECORDS_CART,
  CLEAR_RECORDS_CART,
 } from './mutations-types';

export default {
  [FILL_DETAILS](state, payload) {
    const _state = state;
    _state.details.record = payload.record;
  },
  [FILL_RECORDS_CART](state, payload) {
    const _state = state;
    _state.recordsCart.push(payload);
  },
  [REMOVE_FROM_RECORDS_CART](state, payload) {
    const _state = state;
    _state.recordsCart = _state.recordsCart.filter(elem => elem._wh1_uuid !== payload._wh1_uuid);
  },
  [CLEAR_RECORDS_CART](state, payload) {
    const _state = state;
    _state.recordsCart = payload;
  },
};
